import React, { useMemo, useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import Header from "../../../components/header/Header";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import DriveEtaOutlinedIcon from "@mui/icons-material/DriveEtaOutlined";
import ContactlessOutlinedIcon from "@mui/icons-material/ContactlessOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

import {
  getToken,
  decodeRefreshToken,
  decodeDataToken,
} from "../../../helpers/token/refreshToken";
import { db } from "../../../firebase";
import { onValue, ref, update } from "firebase/database";
import { convertDate } from "../../../helpers/date/convertDate";
import { useTranslation } from "react-i18next";
import { generateOpenPayURL } from "../../../api/openpay/openpay";
import { getAdvanceCashOrder } from "../../../api/booking/advance";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { buttonStyle } from "./style/PendingLater.style";
import "./style/HistoryPendingLater.css";
import { getModels } from "../../../api/resources/model";
import { getEnterpriseEmployeeAddress } from "../../../api/users/enterprise/address/address";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  dateFormat,
  formatDateTime,
  timeFormat,
} from "../../../helpers/date/date";
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import SnackBar from "../../../components/snackbar/SnackBar";
import SubRoutesModal from "../booking/pages/components/SubRoutesModal";
import OriginMapModal from "../booking/pages/components/OriginMapModal";
import OtherPersonModal from "../booking/pages/components/OtherPersonModal";
import {
  getSavedRouteKey as getAddressKey,
  getAddressLabel,
  moveItem,
  normalizeAddress,
} from "../booking/pages/helpers/addressRouteHelpers";

const SUB_ROUTES_GROUP = "history-pending-later-sub-routes";
const RIDER_OPTION_ME = 1;
const RIDER_OPTION_OTHER_PERSON = 2;
const RIDER_OPTION_LABELS = {
  [RIDER_OPTION_ME]: "ME",
  [RIDER_OPTION_OTHER_PERSON]: "OTHER_PERSON",
};
const DEFAULT_PHONE_COUNTRY = "PE";
const DEFAULT_PHONE_DIAL_CODE = "+51";
const PENDING_SERVICE_STATUSES = ["PENDING", "PENDIENTE"];
const STATUS_SERVICE_LABELS = {
  PENDING: "PENDIENTE",
  PENDIENTE: "PENDIENTE",
  RUNNING: "EN RUTA",
  FINISH: "FINALIZADO",
};
const INVALID_FIELDS = {
  riderOption: "riderOption",
  otherPersonName: "otherPersonName",
  otherPersonPhone: "otherPersonPhone",
};

const formatPhoneByCountry = (value, countryCode) => {
  if (countryCode !== DEFAULT_PHONE_COUNTRY) return value;
  if (value.length <= 3) return value;
  if (value.length <= 6) return `${value.slice(0, 3)} ${value.slice(3)}`;
  return `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6, 9)}`;
};

const createMapAddress = ({ address, point }) => ({
  name: address,
  latitude: point.lat,
  longitude: point.lng,
  url: "",
  url_address: "",
});

const buildSubRoutesList = (item) =>
  [...(Array.isArray(item?.subRoutes) ? item.subRoutes : []), item?.destination]
    .filter(Boolean)
    .map(normalizeAddress);

const getPersistedSubRoutes = (routes) =>
  routes.slice(0, -1).map((route, index) => ({
    id: index + 1,
    lat: Number(route.latitude ?? route.lat),
    lng: Number(route.longitude ?? route.lng),
    name: String(route.name || "").toUpperCase(),
  }));

const getRouteDestination = (routes, fallbackDestination) => {
  const routeDestination = routes[routes.length - 1];
  return normalizeAddress(routeDestination || fallbackDestination);
};

const HistoryPendingLater = () => {
  const [booking, setBooking] = useState([]);
  const { t } = useTranslation();
  const dataToken = getToken("dttkn");
  const { enterprise_id, sub_role } = decodeDataToken(dataToken);
  const [listAdvance, setListAdvance] = useState([]);
  const [modelApi, setModelApi] = useState([]);

  const currency = { 1: "PEN", 2: "USD" };

  useEffect(() => {
    const token = getToken("etknre");
    const uid = decodeRefreshToken(token);
    const starCountRef = ref(db, "BookingBusiness/");

    onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data !== null) {
        const compareByDate = (a, b) => {
          const dateB = convertDate(b.date, a.time);
          const dateA = convertDate(a.date, a.time);
          return dateB - dateA;
        };

        setBooking([]);
        setListAdvance([]);
        Object.values(data)
          .sort(compareByDate)
          .map(async (_booking) => {
            if (sub_role === "ADMIN") {
              if (
                _booking.booking_type != 1 &&
                Number(_booking.enterpriseId) === Number(enterprise_id) &&
                _booking.cotizar
              ) {
                _booking.currency = currency[_booking.currency];
                _booking.fullorigin = _booking.origin.name;
                _booking.fulldestination = _booking.destination.name;
                setBooking((oldArray) => [...oldArray, _booking]);
              }
            } else if (
              _booking.booking_type != 1 &&
              Number(_booking.client) === uid &&
              _booking.cotizar
            ) {
              _booking.currency = currency[_booking.currency];
              _booking.fullorigin = _booking.origin.name;
              _booking.fulldestination = _booking.destination.name;
              setBooking((oldArray) => [...oldArray, _booking]);
            }
          });
      }
    });
  }, []);

  useEffect(() => {
    if (booking.length > 0) {
      const getOrderPay = async () => {
        setListAdvance([]);
        booking.map(async (item) => {
          const resp = await getAdvanceCashOrder(item.counterBooking);
          const data = resp.data.resp;
          console.log(data);
          if (data.length > 0) {
            const list = { orderNumber: item.counterBooking, data };
            setListAdvance((oldData) => [...oldData, list]);
          }
        });
      };

      getOrderPay();
    }
  }, [booking]);

  const model = ["", "Sedan", "SUV", "Minivan"];
  const [open, setOpen] = React.useState(false);
  const [uidX, setUid] = useState("");
  const [bookingLater, setBookingLater] = useState();
  const handleClose = () => setOpen(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 5,
    width: { sm: 550, xs: 320 },
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: { sm: 3, xs: 2 },
  };

  const dateOpenpayFormat = () => {
    var fecha = new Date();

    var año = fecha.getFullYear();
    var mes = ("0" + (fecha.getMonth() + 1)).slice(-2); // Agregar un cero inicial si es necesario
    var dia = ("0" + fecha.getDate()).slice(-2); // Agregar un cero inicial si es necesario
    var hora = ("0" + fecha.getHours()).slice(-2); // Agregar un cero inicial si es necesario
    var minuto = ("0" + fecha.getMinutes()).slice(-2); // Agregar un cero inicial si es necesario
    var segundo = ("0" + fecha.getSeconds()).slice(-2); // Agregar un cero inicial si es necesario

    var formatoFecha =
      año + "-" + mes + "-" + dia + "T" + hora + ":" + minuto + ":" + segundo;

    return formatoFecha;
  };

  const generateOpenPayForm = async (booking) => {
    try {
      const dataToken = getToken("dttkn");
      const { name, lastname, phone, email } = decodeDataToken(dataToken);
      const orderID = `${booking.counterBooking}-${Date.now()}`;
      const redirectUrl = `https://business.taximundo.com/voucher/${booking.currency}`;
      // const redirectUrl = `http://localhost:3003/voucher/${booking.currency}`;

      const bookingOpenPay = {
        method: "card",
        amount: Number(booking.advance),
        currency: booking.currency,
        description: `${booking.counterBooking}. PAGO POR SERVICIO DE TRANSPORTE`,
        order_id: orderID,
        confirm: "false",
        send_email: "false",
        redirect_url: redirectUrl,
        due_date: dateOpenpayFormat(),
        customer: {
          name: name,
          last_name: lastname,
          phone_number: phone,
          email: email,
        },
      };

      const response = await generateOpenPayURL(bookingOpenPay);
      if (response.data.message === "success") {
        const data = response.data.data;
        const url = response.data.data.payment_method.url;
        window.open(url, "_blank");
        const openpayData = {
          transaction_id: data.id,
          order_id: data.order_id,
          createBy: "B",
        };
        await update(
          ref(db, `BookingBusiness/${booking.uuid}/openpay`),
          openpayData,
        );
      } else {
        alert("ERROR");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatClientName = (name) => {
    const nameSplit = name.split(" ");
    if (nameSplit.length === 2) {
      return name;
    }
    if (nameSplit.length === 3) {
      return `${nameSplit[0]} ${nameSplit[1]}`;
    }
    if (nameSplit.length > 3) {
      return `${nameSplit[0]} ${nameSplit[2]}`;
    }
    return name;
  };

  const [bookItem, setBookItem] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const [origin, setOrigin] = useState(null);
  const [destination, setDestination] = useState(null);
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [dateEnd, setDateEnd] = useState();
  const [timeEnd, setTimeEnd] = useState();
  const [persons, setPersons] = useState(0);
  const [vehicle, setVehicle] = useState(1);
  const [note, setNote] = useState("");
  const [routeBookItem, setRouteBookItem] = useState(null);
  const [subRoutesList, setSubRoutesList] = useState([]);
  const [openSubRoutesModal, setOpenSubRoutesModal] = useState(false);
  const [openSubRouteMapModal, setOpenSubRouteMapModal] = useState(false);
  const [subRouteSelected, setSubRouteSelected] = useState(null);
  const [riderOption, setRiderOption] = useState(RIDER_OPTION_ME);
  const [openOtherPersonModal, setOpenOtherPersonModal] = useState(false);
  const [otherPersonName, setOtherPersonName] = useState("");
  const [otherPersonPhone, setOtherPersonPhone] = useState("");
  const [otherPersonPhoneCountry, setOtherPersonPhoneCountry] = useState(
    DEFAULT_PHONE_COUNTRY,
  );
  const [phoneCountries, setPhoneCountries] = useState([]);
  const [otherPersonPreview, setOtherPersonPreview] = useState({
    name: "",
    phone: "",
  });
  const [invalidField, setInvalidField] = useState("");

  const [addressApi, setAddressApi] = useState([]);
  const selectedPhoneCountry = useMemo(
    () =>
      phoneCountries.find(
        (country) => country.code === otherPersonPhoneCountry,
      ),
    [phoneCountries, otherPersonPhoneCountry],
  );

  useEffect(() => {
    fetch("/assets/countries.json")
      .then((response) => response.json())
      .then((countries) => {
        if (Array.isArray(countries)) {
          setPhoneCountries(countries);
        }
      })
      .catch(() => {
        setPhoneCountries([]);
      });
  }, []);

  const clearInvalidField = (fieldName) => {
    setInvalidField((currentField) =>
      currentField === fieldName ? "" : currentField,
    );
  };

  const getSelectedRiderData = () => {
    if (riderOption === RIDER_OPTION_ME) {
      return {
        riderOption: RIDER_OPTION_ME,
        riderOptionName: RIDER_OPTION_LABELS[RIDER_OPTION_ME],
        otherPersonName: "",
        otherPersonPhone: "",
      };
    }

    return {
      riderOption,
      riderOptionName: RIDER_OPTION_LABELS[riderOption] ?? "",
      otherPersonName:
        riderOption === RIDER_OPTION_OTHER_PERSON
          ? otherPersonPreview.name
          : "",
      otherPersonPhone:
        riderOption === RIDER_OPTION_OTHER_PERSON
          ? otherPersonPreview.phone
          : "",
    };
  };

  const handleRiderOptionChange = (event) => {
    const value = Number(event.target.value);
    clearInvalidField(INVALID_FIELDS.riderOption);
    setRiderOption(value);
    if (value !== RIDER_OPTION_OTHER_PERSON) {
      setOtherPersonName("");
      setOtherPersonPhone("");
      setOtherPersonPreview({
        name: "",
        phone: "",
      });
      setOtherPersonPhoneCountry(DEFAULT_PHONE_COUNTRY);
    }
  };

  const handleCloseOtherPersonModal = () => {
    setOpenOtherPersonModal(false);
  };

  const handleOpenOtherPersonModal = () => {
    setOpenOtherPersonModal(true);
  };

  const handleOtherPersonNameChange = (event) => {
    clearInvalidField(INVALID_FIELDS.otherPersonName);
    const value = event.target.value
      .toUpperCase()
      .trimStart()
      .replace(/\s+/g, " ");
    setOtherPersonName(value);
  };

  const handleOtherPersonPhoneChange = (event) => {
    clearInvalidField(INVALID_FIELDS.otherPersonPhone);
    const rawValue = event.target.value.replace(/[^\d]/g, "");
    const value = formatPhoneByCountry(rawValue, otherPersonPhoneCountry);
    setOtherPersonPhone(value);
  };

  const handleOtherPersonPhoneCountryChange = (event) => {
    const countryCode = event.target.value;
    const rawValue = otherPersonPhone.replace(/[^\d]/g, "");
    clearInvalidField(INVALID_FIELDS.otherPersonPhone);
    setOtherPersonPhoneCountry(countryCode);
    setOtherPersonPhone(formatPhoneByCountry(rawValue, countryCode));
  };

  const handleAcceptOtherPerson = () => {
    const name = otherPersonName.trim();
    const nameWords = name.split(/\s+/).filter(Boolean);

    if (!name) {
      snackBarDialog("INGRESE EL NOMBRE DE LA OTRA PERSONA", "error");
      setInvalidField(INVALID_FIELDS.otherPersonName);
      return;
    }
    if (nameWords.length < 2) {
      snackBarDialog("INGRESE NOMBRE Y APELLIDO", "error");
      setInvalidField(INVALID_FIELDS.otherPersonName);
      return;
    }
    if (!otherPersonPhone.trim()) {
      snackBarDialog("INGRESE EL TELEFONO DE LA OTRA PERSONA", "error");
      setInvalidField(INVALID_FIELDS.otherPersonPhone);
      return;
    }
    const phoneNumber = otherPersonPhone.trim();
    const phoneDialCode =
      selectedPhoneCountry?.dial_code ?? DEFAULT_PHONE_DIAL_CODE;
    const phone = `${phoneDialCode} ${phoneNumber}`.trim();
    setOtherPersonName(name);
    setOtherPersonPhone(phoneNumber);
    setOtherPersonPreview({
      name,
      phone,
    });
    setInvalidField("");
    handleCloseOtherPersonModal();
  };

  const syncSubRoutes = (nextRoutes) => {
    setSubRoutesList(nextRoutes.filter(Boolean).map(normalizeAddress));
    setSubRouteSelected(null);
  };

  const handleOpenSubRoutesModal = (item) => {
    const selectedItem = item || bookItem;
    if (!selectedItem) return;
    setRouteBookItem(selectedItem);
    if (item || subRoutesList.length === 0) {
      syncSubRoutes(buildSubRoutesList(selectedItem));
    }
    setOpenSubRoutesModal(true);
  };

  const handleCloseSubRoutesModal = () => {
    setOpenSubRoutesModal(false);
    setRouteBookItem(null);
    setSubRouteSelected(null);
  };

  const handleOpenSubRouteMapModal = () => {
    setOpenSubRouteMapModal(true);
  };

  const handleCloseSubRouteMapModal = () => {
    setOpenSubRouteMapModal(false);
  };

  const handleAddSubRoute = (selectedRoute = subRouteSelected) => {
    if (!selectedRoute) {
      snackBarDialog("SELECCIONE UNA SUB RUTA", "error");
      return;
    }

    const selectedKey = getAddressKey(selectedRoute);
    const lastRoute = subRoutesList[subRoutesList.length - 1];
    const isConsecutiveDuplicate =
      lastRoute && getAddressKey(lastRoute) === selectedKey;

    if (isConsecutiveDuplicate) {
      snackBarDialog("NO SE PERMITEN DOS SUBRUTAS IGUALES CONSECUTIVAS", "error");
      return;
    }

    syncSubRoutes([...subRoutesList, selectedRoute]);
  };

  const handleRemoveSubRoute = (routeIndex) => {
    if (subRoutesList.length <= 1) return;
    syncSubRoutes(subRoutesList.filter((_, index) => index !== routeIndex));
  };

  const handleSubRoutesDragEnd = (event) => {
    if (event.canceled || !event.operation?.source) return;

    const fromIndex = event.operation.source.initialIndex;
    const toIndex = event.operation.source.index;

    if (
      !Number.isInteger(fromIndex) ||
      !Number.isInteger(toIndex) ||
      fromIndex < 0 ||
      toIndex < 0 ||
      fromIndex >= subRoutesList.length ||
      toIndex >= subRoutesList.length ||
      fromIndex === toIndex
    ) return;

    const nextRoutes = moveItem(subRoutesList, fromIndex, toIndex);
    const hasConsecutiveDuplicates = nextRoutes.some(
      (route, index) =>
        index > 0 &&
        getAddressKey(route) === getAddressKey(nextRoutes[index - 1]),
    );

    if (hasConsecutiveDuplicates) {
      snackBarDialog("NO SE PERMITEN DOS SUBRUTAS IGUALES CONSECUTIVAS", "error");
      return;
    }

    syncSubRoutes(nextRoutes);
  };

  const handleAcceptSubRouteMapLocation = (location) => {
    handleAddSubRoute(createMapAddress(location));
    handleCloseSubRouteMapModal();
  };

  const handleAcceptSubRoutes = () => {
    if (subRoutesList.length === 0) return;

    const routeDestination = getRouteDestination(
      subRoutesList,
      routeBookItem?.destination || bookItem?.destination,
    );

    setDestination(routeDestination);
    handleCloseSubRoutesModal();
  };

  useEffect(() => {
    const getAddressEnterprise = async () => {
      try {
        const token = getToken("etknre");
        const dataToken = getToken("dttkn");

        if (dataToken != null && token != null) {
          const { enterprise_id } = decodeDataToken(dataToken);
          const uid = decodeRefreshToken(token);

          setAddressApi([]);
          const response = await getEnterpriseEmployeeAddress(
            token,
            uid,
            enterprise_id,
          );
          setAddressApi(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    const models = async () => {
      try {
        const response = await getModels();
        const data = response.data.filter((model) => model.id);
        setModelApi(data);
      } catch (error) {
        console.log(error);
      }
    };
    models();
    getAddressEnterprise();
  }, []);

  const checkTime = () => {
    const today = new Date();
    const { day, month, year, hour, minute } = formatDateTime(
      date.$d ?? date,
      time.$d ?? time,
    );

    const dateOrder = new Date(year, month, day, hour, minute, 0);
    const diffInMillisec = dateOrder.getTime() - today.getTime();
    const diffInMin = diffInMillisec / (1000 * 60);

    if (diffInMin <= 60) {
      snackBarDialog("TODA RESERVA DEBE SER MAYOR O IGUAL A 1 HORA", "error");
      return;
    }

    return true;
  };

  const updateBookingLater = async (e, item) => {
    e.preventDefault();
    try {
      if (riderOption === RIDER_OPTION_OTHER_PERSON) {
        if (!otherPersonPreview.name) {
          setInvalidField(INVALID_FIELDS.otherPersonName);
          setOpenOtherPersonModal(true);
          snackBarDialog("INGRESE EL NOMBRE DE LA OTRA PERSONA", "error");
          return;
        }
        if (!otherPersonPreview.phone) {
          setInvalidField(INVALID_FIELDS.otherPersonPhone);
          setOpenOtherPersonModal(true);
          snackBarDialog("INGRESE EL TELEFONO DE LA OTRA PERSONA", "error");
          return;
        }
      }
      setInvalidField("");

      if (checkTime()) {
        const refPath = `BookingBusiness/${item.uuid}`;
        const refDB = ref(db, refPath);
        let dateend = "";
        let timeend = "";
        if (item.booking_type == 3) {
          dateend = dateEnd.$d ? dateFormat(dateEnd.$d) : dateFormat(dateEnd);
          timeend = timeEnd.$d ? timeFormat(timeEnd.$d) : timeFormat(timeEnd);
        }

        const nextDestination = normalizeAddress(destination);
        const nextSubRoutesList =
          subRoutesList.length > 0
            ? [...subRoutesList.slice(0, -1), nextDestination]
            : [nextDestination];
        const selectedRiderData = getSelectedRiderData();

        const data = {
          origin: {
            lat: origin.lat ?? origin.latitude,
            lng: origin.lng ?? origin.longitude,
            name: origin.name,
          },
          destination: {
            lat: destination.lat ?? destination.latitude,
            lng: destination.lng ?? destination.longitude,
            name: destination.name,
          },
          subRoutes: getPersistedSubRoutes(nextSubRoutesList),
          date: date.$d ? dateFormat(date.$d) : dateFormat(date),
          time: time.$d ? timeFormat(time.$d) : timeFormat(time),
          dateEnd: dateend,
          timeEnd: timeend,
          persons: Number(persons) ?? 1,
          vehicle: Number(vehicle) ?? 1,
          note: note.toUpperCase() ?? "",
          riderOption: selectedRiderData.riderOption,
          riderOptionName: selectedRiderData.riderOptionName,
          otherPersonName: selectedRiderData.otherPersonName,
          otherPersonPhone: selectedRiderData.otherPersonPhone,
        };
        await update(refDB, data);
        snackBarDialog("DATOS ACTUALIZADOS");
        handleCloseEdit();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatterTimePicker = (date, time) => {
    const [day, month, year] = date.split("/");
    const [hourMin, amPm] = time.split(" ");
    const [hour, minute] = hourMin.split(":");
    const realHour =
      amPm == "AM" ? hour : hour == 12 ? hour : parseInt(hour) + 12;
    return new Date(year, month - 1, day, realHour, minute);
  };

  const [stateSnk, setStateSnk] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [messageSnk, setMessageSnk] = useState("");
  const vertical = "top";
  const horizontal = "center";

  const handleSnkClose = () => setStateSnk(false);

  const snackBarDialog = (message, severity = "success") => {
    setMessageSnk(message);
    setSeverity(severity);
    setStateSnk(true);
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title={""} subtitle={t("booking_pending")} />
      </Box>

      {booking.length > 0 ? (
        booking.map((booking, index) => (
          <Card key={index} sx={{ border: 1, margin: "1px -3px 2px -3px" }}>
            <CardContent>
              <Grid container>
                <Grid item xs={4} sm={6}>
                  <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                    TM-{booking.counterBooking}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={8}
                  sm={booking.booking_type === 3 ? 3 : 6}
                  textAlign={"end"}
                >
                  <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                    {booking.date} - {booking.time}
                  </Typography>
                </Grid>
                {booking.booking_type === 3 && (
                  <Grid item xs={12} sm={3} textAlign={"end"}>
                    <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                      {booking.dateEnd} - {booking.timeEnd}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    color={"primary"}
                    sx={{ fontWeight: "bold" }}
                  >
                    A Origen: {booking.origin.name}
                  </Typography>
                </Grid>

                {Array.isArray(booking.subRoutes) &&
                  booking.subRoutes.length > 0 && (
                    <Grid item xs={12}>
                      {[...booking.subRoutes]
                        .sort((a, b) => Number(a.id) - Number(b.id))
                        .map((subRoute, index) => (
                          <Typography
                            key={subRoute.id}
                            variant="body2"
                            sx={{ fontWeight: "bold" }}
                          >
                            {index + 1}. {subRoute.name}
                          </Typography>
                        ))}
                    </Grid>
                  )}

                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    color={"error"}
                    sx={{ fontWeight: "bold" }}
                  >
                    B Destino: {booking.destination.name}
                  </Typography>
                </Grid>
                {booking.driver ? (
                  <Grid item xs={12}>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      Conductor: {booking.driver.name} {booking.driver.lastname}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      Vehicle: {booking.driver.brand} {booking.driver.model} -
                      {booking.driver.plate}
                    </Typography>
                  </Grid>
                ) : null}
                <Grid item xs={4}>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Vehicle: {model[booking.vehicle]}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Persons: {booking.persons}
                  </Typography>
                </Grid>

                <Grid item xs={4}>
                  {sub_role === "ADMIN" && (
                    <Typography
                      color={"primary"}
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        fontSize: "13px",
                        fontWeight: "bold",
                        gap: "4px",
                      }}
                    >
                      <PersonIcon sx={{ fontSize: 16 }} />
                      {booking.otherPersonName
                        ? String(booking.otherPersonName).toUpperCase()
                        : formatClientName(booking.clientName)}
                    </Typography>
                  )}
                </Grid>

                {booking.otherPersonPhone && (
                  <Grid item xs={12}>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      Telefono pasajero: {booking.otherPersonPhone}
                    </Typography>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Nota: {booking.note}
                  </Typography>
                </Grid>

                {listAdvance.map((item, index) => {
                  console.log("item", item);
                  const check =
                    Number(booking.counterBooking) == Number(item.orderNumber);

                  if (check) {
                    return (
                      <div key={index}>
                        {item.data.map((adv, idx) => {
                          return (
                            <div
                              key={idx}
                              style={{ width: "100%", fontWeight: "bold" }}
                            >
                              {idx + 1}.- {adv.currency} {adv.amount}{" "}
                              {adv.status} {adv.operation_date}
                            </div>
                          );
                        })}
                      </div>
                    );
                  }
                })}
              </Grid>
            </CardContent>
            <CardActions sx={{ mt: -2 }}>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={3} md={2}>
                  <p
                    style={{
                      fontWeight: "bold",
                      background: "white",
                      borderRadius: 3,
                      borderStyle: "solid",
                      borderColor: "black",
                      borderWidth: 1,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "black",
                      width: "100%",
                      height: "100%",
                      fontSize: 15,
                    }}
                  >
                    <MonetizationOnOutlinedIcon />
                    &nbsp;
                    {booking.openpay
                      ? booking.openpay?.status === "pending"
                        ? "PENDIENTE"
                        : "PAGADO"
                      : "PENDIENTE"}
                  </p>
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                  <p
                    className="status-service-border"
                    style={{
                      fontWeight: "bold",
                      background: "white",
                      borderRadius: 3,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "black",
                      width: "100%",
                      height: "100%",
                      fontSize: 15,
                    }}
                  >
                    <span className="status-service-border__content">
                      <DriveEtaOutlinedIcon />
                      &nbsp;
                      {booking.driver &&
                      PENDING_SERVICE_STATUSES.includes(booking.statusService)
                        ? "ASIGNADO"
                        : (STATUS_SERVICE_LABELS[booking.statusService] ??
                          booking.statusService)}
                    </span>
                  </p>
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                  {booking.payment_type == 1 && (
                    <p
                      style={{
                        fontWeight: "bold",
                        background: "white",
                        borderRadius: 3,
                        borderStyle: "solid",
                        borderColor: "black",
                        borderWidth: 1,
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "black",
                        width: "100%",
                        height: "100%",
                        fontSize: 15,
                      }}
                    >
                      {booking.currency} {booking.total}
                    </p>
                  )}
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                  <Button
                    fullWidth
                    size="small"
                    color="info"
                    variant="contained"
                    sx={{ fontWeight: "bold", background: "#128C7E" }}
                    href={`https://api.whatsapp.com/send?phone=+51958200900&text=*Pedido:* ${booking.counterBooking},%0A *Cliente:* ${booking.clientName},%0A *Origen:* ${booking.origin.name}, *Destino:* ${booking.destination.name} `}
                    target={"_blank"}
                    onClick={(e) => {
                      setUid(booking.uuid);
                    }}
                  >
                    Consultar&nbsp;
                    <WhatsAppIcon />
                  </Button>
                </Grid>
                {/*   */}
                {booking.total > 0 &&
                  booking.openpay &&
                  booking.openpay.btnPay && (
                    <Grid item xs={6} sm={3} md={2}>
                      <Button
                        fullWidth
                        size="small"
                        color="primary"
                        variant="contained"
                        sx={{ fontWeight: "bold" }}
                        onClick={(e) => {
                          console.log(booking.uuid);
                          setOpen(true);
                          setUid(booking.uuid);
                          setBookingLater(booking);
                        }}
                      >
                        PAGAR&nbsp;
                        <ContactlessOutlinedIcon />
                      </Button>
                      {/* CREAR LA FUNCIONALIDAD PARA PAGAR */}
                      <Modal open={open} onClose={handleClose}>
                        <Box sx={style}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold" }}
                            textAlign={"center"}
                          >
                            PAGAR PEDIDO?
                          </Typography>
                          <Stack direction="row" spacing={2}>
                            <Button
                              fullWidth
                              size="small"
                              color="primary"
                              variant="contained"
                              sx={{ fontWeight: "bold" }}
                              onClick={(e) => {
                                setOpen(false);
                                generateOpenPayForm(bookingLater);
                              }}
                            >
                              CONFIRMAR
                            </Button>
                            <Button
                              fullWidth
                              size="small"
                              color="error"
                              variant="contained"
                              sx={{ fontWeight: "bold" }}
                              onClick={(e) => setOpen(false)}
                            >
                              CANCELAR
                            </Button>
                          </Stack>
                        </Box>
                      </Modal>
                    </Grid>
                  )}

                <Grid item xs={6} sm={3} md={2}>
                  <p
                    style={{ ...buttonStyle, cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      console.log(booking);
                      setBookItem(booking);
                      setDate(dayjs(booking.date, "DD/MM/YYYY").toDate());
                      setTime(formatterTimePicker(booking.date, booking.time));

                      if (booking.booking_type == 3) {
                        setDateEnd(
                          dayjs(booking.dateEnd, "DD/MM/YYYY").toDate(),
                        );
                        setTimeEnd(
                          formatterTimePicker(booking.dateEnd, booking.timeEnd),
                        );
                      }

                      setOrigin(booking.origin);
                      setDestination(booking.destination);
                      syncSubRoutes(buildSubRoutesList(booking));
                      setPersons(booking.persons);
                      setVehicle(booking.vehicle);
                      setNote(booking.note);
                      const hasOtherPersonData =
                        Boolean(booking.otherPersonName) &&
                        Boolean(booking.otherPersonPhone);
                      const nextRiderOption = hasOtherPersonData
                        ? RIDER_OPTION_OTHER_PERSON
                        : Number(booking.riderOption) || RIDER_OPTION_ME;
                      setRiderOption(nextRiderOption);
                      if (nextRiderOption === RIDER_OPTION_OTHER_PERSON) {
                        const nextOtherPersonName = String(
                          booking.otherPersonName ?? "",
                        );
                        const nextOtherPersonPhone = String(
                          booking.otherPersonPhone ?? "",
                        );
                        setOtherPersonName(nextOtherPersonName);
                        setOtherPersonPhone(
                          nextOtherPersonPhone
                            .replace(DEFAULT_PHONE_DIAL_CODE, "")
                            .trim(),
                        );
                        setOtherPersonPreview({
                          name: nextOtherPersonName,
                          phone: nextOtherPersonPhone,
                        });
                      } else {
                        setOtherPersonName("");
                        setOtherPersonPhone("");
                        setOtherPersonPreview({
                          name: "",
                          phone: "",
                        });
                        setOtherPersonPhoneCountry(DEFAULT_PHONE_COUNTRY);
                      }
                      setInvalidField("");
                      handleOpenEdit();
                    }}
                  >
                    <CreateOutlinedIcon />
                    EDITAR
                  </p>
                </Grid>
              </Grid>
            </CardActions>
          </Card>
        ))
      ) : (
        <div>{t("NO HAY RESERVAS PENDIENTES")}</div>
      )}

      <Modal open={openEdit} onClose={handleCloseEdit}>
        <Box sx={style}>
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              sm={riderOption === RIDER_OPTION_OTHER_PERSON ? 6 : 12}
            >
              <FormControl
                fullWidth
                error={invalidField === INVALID_FIELDS.riderOption}
              >
                <InputLabel>Para quien es el Servicio</InputLabel>
                <Select
                  value={riderOption}
                  id="riderOption"
                  name="riderOption"
                  label="Para quien es el Servicio"
                  onChange={(event) => {
                    const selectedRiderOption = Number(event.target.value);
                    handleRiderOptionChange(event);
                    if (selectedRiderOption === RIDER_OPTION_OTHER_PERSON) {
                      handleOpenOtherPersonModal();
                    }
                  }}
                >
                  <MenuItem value={0} disabled>
                    Seleccione una opcion
                  </MenuItem>
                  <MenuItem value={RIDER_OPTION_ME}>Para Mi</MenuItem>
                  <MenuItem value={RIDER_OPTION_OTHER_PERSON}>
                    Para Otra persona
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {riderOption === RIDER_OPTION_OTHER_PERSON && (
              <Grid item xs={12} sm={6}>
                <Box
                  role="button"
                  tabIndex={0}
                  onClick={handleOpenOtherPersonModal}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      handleOpenOtherPersonModal();
                    }
                  }}
                  sx={{
                    border: "1px solid",
                    borderColor:
                      invalidField === INVALID_FIELDS.otherPersonName ||
                      invalidField === INVALID_FIELDS.otherPersonPhone
                        ? "error.main"
                        : "divider",
                    borderRadius: "4px",
                    minHeight: 56,
                    px: 1,
                    display: "flex",
                    textAlign: "center",
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    "&:hover": {
                      borderColor: "primary.main",
                    },
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {otherPersonPreview.name || "NOMBRE"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" noWrap>
                    {otherPersonPreview.phone || "TELEFONO"}
                  </Typography>
                </Box>
              </Grid>
            )}

            <Grid item xs={12} sm={12}>
              {addressApi ? (
                <Autocomplete
                  value={origin}
                  disablePortal
                  name="addressOrigin"
                  id="combo-box-origin"
                  onChange={(e, newValue) => {
                    setOrigin(newValue);
                  }}
                  options={addressApi}
                  getOptionLabel={(option) => `${option.name}`}
                  renderInput={(params) => (
                    <TextField {...params} label={t("origin")} />
                  )}
                />
              ) : (
                <TextField
                  id="origin"
                  label="ORIGEN"
                  fullWidth
                  variant="outlined"
                  value={bookItem?.origin?.name}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={12}>
              {addressApi ? (
                <Autocomplete
                  value={destination}
                  disablePortal
                  name="addressDestination"
                  id="combo-box-destination"
                  onChange={(e, newValue) => {
                    setDestination(newValue);
                    if (newValue) {
                      syncSubRoutes(
                        subRoutesList.length > 0
                          ? [...subRoutesList.slice(0, -1), newValue]
                          : [newValue],
                      );
                    }
                  }}
                  options={addressApi}
                  getOptionLabel={(option) => `${option.name}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("destination")}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              color="error"
                              aria-label="Editar ruta"
                              onMouseDown={(event) => {
                                event.preventDefault();
                              }}
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                handleOpenSubRoutesModal();
                              }}
                            >
                              <LocationOnIcon fontSize="small" />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              ) : (
                <TextField
                  id="destination"
                  label="DESTINO"
                  fullWidth
                  variant="outlined"
                  value={bookItem?.destination?.name}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        size="small"
                        color="error"
                        aria-label="Editar ruta"
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          handleOpenSubRoutesModal();
                        }}
                      >
                        <LocationOnIcon fontSize="small" />
                      </IconButton>
                    ),
                  }}
                />
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={2}>
                  <MobileDatePicker
                    label={t("date")}
                    inputFormat="DD/MM/YYYY"
                    name="date"
                    value={date}
                    onChange={(newValue) => {
                      setDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Stack>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={3}>
                  <MobileTimePicker
                    label={t("time")}
                    value={time}
                    name="timeEnd"
                    onChange={(newValue) => {
                      setTime(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Stack>
              </LocalizationProvider>
            </Grid>

            {bookItem?.booking_type == 3 && (
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={2}>
                    <MobileDatePicker
                      label={t("date")}
                      inputFormat="DD/MM/YYYY"
                      name="dateEnd"
                      value={dateEnd}
                      onChange={(newValue) => setDateEnd(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Stack>
                </LocalizationProvider>
              </Grid>
            )}

            {bookItem?.booking_type == 3 && (
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={3}>
                    <MobileTimePicker
                      label={t("time")}
                      value={timeEnd}
                      name="timeEnd"
                      onChange={(newValue) => setTimeEnd(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Stack>
                </LocalizationProvider>
              </Grid>
            )}

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>{t("vehicle")}</InputLabel>
                <Select
                  value={vehicle}
                  id="vehicle"
                  name="vehicle"
                  label={t("vehicle")}
                  onChange={(e) => {
                    setVehicle(e.target.value);
                  }}
                >
                  {modelApi.map((model, index) => (
                    <MenuItem key={index} value={model.id}>
                      {t(model.name)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id="outlined-basic"
                label="PERSONAS"
                fullWidth
                type="number"
                variant="outlined"
                value={persons}
                onChange={(e) => setPersons(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                id="outlined-basic"
                label="NOTAS"
                fullWidth
                variant="outlined"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <Button
                fullWidth
                type="submit"
                color="error"
                variant="contained"
                size="large"
                sx={{ height: "100%" }}
                onClick={handleCloseEdit}
              >
                CERRAR
              </Button>
            </Grid>
            <Grid item xs={6} md={6}>
              <Button
                fullWidth
                type="submit"
                color="primary"
                variant="contained"
                size="large"
                sx={{ height: "100%" }}
                onClick={(e) => updateBookingLater(e, bookItem)}
              >
                ACTUALIZAR
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <SubRoutesModal
        open={openSubRoutesModal}
        onClose={handleCloseSubRoutesModal}
        onAccept={handleAcceptSubRoutes}
        addressOrigin={normalizeAddress(
          routeBookItem?.origin || bookItem?.origin,
        )}
        subRoutesList={subRoutesList}
        handleSubRoutesDragEnd={handleSubRoutesDragEnd}
        getAddressKey={getAddressKey}
        getAddressLabel={getAddressLabel}
        handleRemoveSubRoute={handleRemoveSubRoute}
        subRoutesGroup={SUB_ROUTES_GROUP}
        subRouteSelected={subRouteSelected}
        addressApi={addressApi || []}
        handleAddSubRoute={handleAddSubRoute}
        handleOpenSubRouteMapModal={handleOpenSubRouteMapModal}
      />

      <OriginMapModal
        open={openSubRouteMapModal}
        onClose={handleCloseSubRouteMapModal}
        address=""
        coordinate={null}
        onLocationAccept={handleAcceptSubRouteMapLocation}
      />

      <OtherPersonModal
        open={openOtherPersonModal}
        onClose={handleCloseOtherPersonModal}
        otherPersonName={otherPersonName}
        handleOtherPersonNameChange={handleOtherPersonNameChange}
        otherPersonPhone={otherPersonPhone}
        handleOtherPersonPhoneChange={handleOtherPersonPhoneChange}
        otherPersonPhoneCountry={otherPersonPhoneCountry}
        phoneCountries={phoneCountries}
        handleOtherPersonPhoneCountryChange={
          handleOtherPersonPhoneCountryChange
        }
        handleAcceptOtherPerson={handleAcceptOtherPerson}
        invalidField={invalidField}
        invalidFields={INVALID_FIELDS}
      />

      <SnackBar
        stateSnk={stateSnk}
        vertical={vertical}
        horizontal={horizontal}
        duration={4000}
        handleClose={handleSnkClose}
        severity={severity}
        messageSnk={messageSnk}
      />
    </>
  );
};

export default HistoryPendingLater;
